import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { GbgrundstueckbemerkungService, GrundstueckBemerkungDetailEntry, GrundstueckId } from '../../../../core/gb-api';
import { AppConfigService } from '../../../../core/services/app-config.service';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { HistoryMode } from '../../../../core/services/HistoryMode';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AbstractComponent } from '../../../components/abstract-component/abstract.component';
import { ListLoaderObservable } from '../../../components/list-loader/list-loader-observable';
import { ListLoader } from '../../../components/list-loader/list-loader';
import { BeschreibungTableWrapperComponent } from '../../../components/table/beschreibung-table-wrapper.component';
import { ListLoaderWrapperComponent } from '../../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../../directives/history.directive';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-bemerkung',
  templateUrl: './grundstueck-bemerkung.component.html',
  styleUrls: ['./grundstueck-bemerkung.component.scss'],
  imports: [BeschreibungTableWrapperComponent, ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, TranslatePipe]
})
export class GrundstueckBemerkungComponent extends AbstractComponent implements OnChanges, OnDestroy {
  _grundstueckId: GrundstueckId;
  listLoader: ListLoader<GrundstueckBemerkungDetailEntry>;

  historischeDatenSubscription;

  @Input()
  anzeigenHistorischeDaten = true;
  @Input()
  tableFullWidth = false;
  @Input()
  hasRight = true;
  @Input()
  isMeldung = false;

  constructor(
    private timepointService: TimepointService,
    private grundstueckBemerkungService: GbgrundstueckbemerkungService,
    private appConfigService: AppConfigService
  ) {
    super();
    keysToTranslate<string>(['BemerkungGrundbuch']);
  }

  @Input()
  set grundstueckId(value: GrundstueckId) {
    this._grundstueckId = value;
    if (!value) {
      return;
    }
  }

  get grundstueckId(): GrundstueckId {
    return this._grundstueckId;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.grundstueckId.currentValue) {
      return;
    }
    this.historischeDatenSubscription = this.appConfigService.einstellungHistorischeDaten$.subscribe((hist) => {
      this.update();
    });
  }

  update() {
    const historischeDaten = this.anzeigenHistorischeDaten
      ? this.appConfigService.einstellungHistorischeDaten
      : HistoryMode.HistoryMode.OHNE_HIST;
    const timepointCtx = this.timepointService.timepointCtx;
    if (this.isMeldung) {
      const observable = this.grundstueckBemerkungService.loadGrundstueckBemerkungSichtGbMeldung(
        //
        this._grundstueckId.id, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId, //
        historischeDaten //
      );
      this.listLoader = new ListLoaderObservable<GrundstueckBemerkungDetailEntry>(undefined, 1, observable);
    } else {
      const observable = this.grundstueckBemerkungService.loadGrundstueckBemerkungSichtGrundstueck(
        //
        this._grundstueckId.id, //
        timepointCtx.timepointIso, //
        timepointCtx.timepointId, //
        historischeDaten //
      );
      this.listLoader = new ListLoaderObservable<GrundstueckBemerkungDetailEntry>(undefined, 1, observable);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.historischeDatenSubscription?.unsubscribe();
  }
}
